'use strict';

angular.module('cgmemApp')
.controller('FrontDeskAutoCheckInCtrl', function ($scope, AppConfig, CheckIn, $uibModal) {
    this.appConfig = null;
    this.wellOpen = true;
    this.lanesIn = 3;
    this.poolCapacity = 0;
    
    AppConfig.get()
        .then(ac => this.appConfig = ac);

    this.activeCheckIns = CheckIn.getActive();
    this.countUniqueAccounts = () => _.uniq(this.activeCheckIns.map(ci => ci.accountId)).length;
    this.currentPage = 1;

    $scope.$watchGroup(['autocheckin.wellOpen', 'autocheckin.lanesIn', 'autocheckin.appConfig'], () => {
        if(this.appConfig)
            this.poolCapacity = this.appConfig.poolCapacity.fullCapacity
                                - this.appConfig.poolCapacity.laneReduction * parseInt(this.lanesIn)
                                - this.appConfig.poolCapacity.wellReduction * (this.wellOpen ? 0 : 1);
    })

    this.checkOut = (_id, guestOf, firstName, commonName, lastName, ev) => {
        if(ev.shiftKey)
            CheckIn.checkOut([_id]);
        else {
            $uibModal.open({
                templateUrl:'checkOut.html',
                resolve: {
                    name: () => (guestOf ? 'Guest of ' : '') + (firstName || commonName) + ' ' + lastName
                },
                controller: 'CheckOutModalCtrl',
                controllerAs: 'coc'
            })
            .result
            .then( () => {
                CheckIn.checkOut([_id]);
            })
            .catch( () => {})
        }
    }

    this.checkOutAll = () => {
        $uibModal.open({
            templateUrl:'checkOutAll.html'
        })
        .result
        .then( () => {
            CheckIn.checkOutAll();
        })
        .catch( () => {})
    }
})
.controller('CheckOutModalCtrl', function (name) {
    this.name = name;
});

